var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _vm.exhibition
        ? _c("div", { staticClass: "big_box" }, [
            _c("div", { staticClass: "medium_box fix" }, [
              _c("div", { staticClass: "left_box l fix" }, [
                _c("div", { staticClass: "left_small_box l" }, [
                  _c("img", {
                    attrs: {
                      src: _vm._f("fileWxPath")(_vm.entityForm.avatar),
                      alt: "",
                    },
                  }),
                ]),
                _c("div", { staticClass: "right_small_box l" }, [
                  _c(
                    "div",
                    { staticClass: "btn_box" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "l",
                          staticStyle: {
                            margin: "0 8px",
                            "font-weight": "bold",
                          },
                        },
                        [_vm._v(_vm._s(_vm.entityForm.custName))]
                      ),
                      _vm.entityForm.wantLevelName
                        ? _c("a-button", { staticClass: "a_btn_box l" }, [
                            _vm._v(_vm._s(_vm.entityForm.wantLevelName)),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "right_box r fix" },
                [
                  false
                    ? _c("div", { staticClass: "l" }, [_vm._v("电话")])
                    : _vm._e(),
                  false
                    ? _c("div", { staticClass: "l wechat" }, [_vm._v("企微")])
                    : _vm._e(),
                  _c(
                    "a-button",
                    { staticClass: "r", on: { click: _vm.compile } },
                    [_vm._v("编辑")]
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "nav_info_box" }, [
        _c(
          "div",
          { staticClass: "info_item", staticStyle: { width: "175px" } },
          [
            _c(
              "span",
              { staticClass: "name" },
              [_c("a-icon", { attrs: { type: "home" } }), _vm._v(" 企业")],
              1
            ),
            _c("span", { staticClass: "value el" }, [
              _vm._v(
                _vm._s(
                  _vm.entityForm.companyName
                    ? _vm.entityForm.companyName
                    : "暂无信息"
                )
              ),
            ]),
          ]
        ),
        _c("div", { staticClass: "info_item" }, [
          _c(
            "span",
            { staticClass: "name" },
            [_c("a-icon", { attrs: { type: "mobile" } }), _vm._v(" 电话")],
            1
          ),
          _c("span", { staticClass: "value" }, [
            _vm._v(
              _vm._s(
                _vm.entityForm.telephone ? _vm.entityForm.telephone : "暂无信息"
              )
            ),
          ]),
        ]),
        _vm.entityForm.followUserInfo
          ? _c("div", { staticClass: "info_item" }, [
              _c(
                "span",
                { staticClass: "name" },
                [_c("a-icon", { attrs: { type: "user" } }), _vm._v(" 跟进人")],
                1
              ),
              _c("span", { staticClass: "value" }, [
                _vm.entityForm.followUserInfo
                  ? _c("img", {
                      staticClass: "header",
                      attrs: {
                        src: _vm.entityForm.followUserInfo.headImg,
                        alt: "",
                      },
                    })
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm.imgList.length > 0
          ? _c("div", { staticClass: "info_item" }, [
              _c(
                "span",
                { staticClass: "name" },
                [_c("a-icon", { attrs: { type: "user" } }), _vm._v(" 共享人")],
                1
              ),
              _c(
                "span",
                { staticClass: "value more" },
                _vm._l(_vm.imgList, function (item, index) {
                  return _c("img", {
                    key: index,
                    staticClass: "header",
                    attrs: { src: item.headImg, alt: "" },
                  })
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm.entityForm.dealChance
          ? _c("div", { staticClass: "info_item" }, [
              _c(
                "span",
                { staticClass: "name" },
                [
                  _c("a-icon", { attrs: { type: "pie-chart" } }),
                  _vm._v(" 成交概率"),
                ],
                1
              ),
              _c("span", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.entityForm.dealChance)),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm.exhibition
        ? _c("div", { staticClass: "content_box fix" }, [
            _c(
              "div",
              {
                staticClass: "content_small_box ",
                class: { active: _vm.index === 1 },
                on: {
                  click: function ($event) {
                    return _vm.change(1)
                  },
                },
              },
              [_vm._v("联系人资料 ")]
            ),
            _c(
              "div",
              {
                staticClass: "content_small_box ",
                class: { active: _vm.index === 2 },
                on: {
                  click: function ($event) {
                    return _vm.change(2)
                  },
                },
              },
              [_vm._v("成交记录 ")]
            ),
            _c(
              "div",
              {
                staticClass: "content_small_box ",
                class: { active: _vm.index === 3 },
                on: {
                  click: function ($event) {
                    return _vm.change(3)
                  },
                },
              },
              [_vm._v("跟进记录 ")]
            ),
            _c(
              "div",
              {
                staticClass: "content_small_box",
                class: { active: _vm.index === 4 },
                on: {
                  click: function ($event) {
                    return _vm.change(4)
                  },
                },
              },
              [_vm._v("操作日志 ")]
            ),
            _c(
              "div",
              {
                staticClass: "content_small_box",
                class: { active: _vm.index === 5 },
                on: {
                  click: function ($event) {
                    return _vm.change(5)
                  },
                },
              },
              [_vm._v("客户轨迹 ")]
            ),
            _c(
              "div",
              {
                staticClass: "content_small_box",
                class: { active: _vm.index === 6 },
                on: {
                  click: function ($event) {
                    return _vm.change(6)
                  },
                },
              },
              [_vm._v("保有车辆 ")]
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.index === 1,
              expression: "index===1",
            },
          ],
        },
        [
          _c(
            "a-form",
            {
              staticStyle: { padding: "0 15px" },
              attrs: {
                form: _vm.form,
                "label-col": { span: 5 },
                "wrapper-col": { span: 7 },
                "point-events": "false",
              },
              on: { submit: _vm.handleSubmit },
            },
            [
              _c("div", {
                staticClass: "info_box",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.have === 1 ? "▶ 基本信息" : "▼ 基本信息"
                  ),
                },
                on: { click: _vm.fold },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.have === 2,
                      expression: "have===2",
                    },
                  ],
                },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "客户名称" } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "custName",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "请输入姓名",
                                          },
                                        ],
                                      },
                                    ],
                                    expression:
                                      "['custName', { rules: [{ required: true, message: '请输入姓名' }] }]",
                                  },
                                ],
                                attrs: {
                                  disabled: _vm.show,
                                  placeholder: "请输入姓名",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "公司名称" } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "companyName",
                                      {
                                        rules: [
                                          {
                                            required:
                                              _vm.custCategoryId > 30003001,
                                            message: "请输入公司名称",
                                          },
                                        ],
                                      },
                                    ],
                                    expression:
                                      "['companyName', { rules: [{ required: custCategoryId > 30003001 , message: '请输入公司名称' }] }]",
                                  },
                                ],
                                attrs: {
                                  placeholder: "请输入公司名称",
                                  disabled: _vm.show,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "手机号" } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "telephone",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "请输入手机号",
                                          },
                                        ],
                                      },
                                    ],
                                    expression:
                                      "['telephone', { rules: [{ required: true, message: '请输入手机号' }] }]",
                                  },
                                ],
                                attrs: {
                                  disabled: _vm.show,
                                  placeholder: "请输入手机号",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "客户性别" } },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "sex",
                                        {
                                          rules: [
                                            {
                                              required: true,
                                              message: "请选择性别",
                                            },
                                          ],
                                        },
                                      ],
                                      expression:
                                        "['sex', { rules: [{ required: true, message: '请选择性别' }] }]",
                                    },
                                  ],
                                  attrs: { disabled: _vm.show },
                                  on: { change: _vm.onChange },
                                },
                                [
                                  _c("a-radio", { attrs: { value: 1 } }, [
                                    _vm._v(" 男 "),
                                  ]),
                                  _c("a-radio", { attrs: { value: 0 } }, [
                                    _vm._v(" 女 "),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "出生日期" } },
                            [
                              _c("a-date-picker", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "birthday",
                                      {
                                        rules: [
                                          { required: false, message: "" },
                                        ],
                                      },
                                    ],
                                    expression:
                                      "['birthday', { rules: [{ required: false, message: '' }] }]",
                                  },
                                ],
                                attrs: {
                                  disabled: _vm.show,
                                  "value-format": "YYYY-MM-DD",
                                },
                                on: { change: _vm.onChangeDate },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "民族" } },
                            [
                              _c("a-select", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["nationId"],
                                    expression: "['nationId']",
                                  },
                                ],
                                staticStyle: { width: "250px" },
                                attrs: {
                                  disabled: _vm.show,
                                  options: _vm.nation,
                                },
                                on: { change: _vm.handleChange6 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "身份证号" } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "idCard",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "请输入身份证号码",
                                          },
                                        ],
                                      },
                                    ],
                                    expression:
                                      "['idCard', { rules: [{ required: true, message: '请输入身份证号码' }] }]",
                                  },
                                ],
                                attrs: {
                                  disabled: _vm.show,
                                  "max-length": 18,
                                  placeholder: "请输入身份证号",
                                },
                                on: { input: _vm.handleIdCardChange },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "社会统一信用代码" } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "uscCode",
                                      {
                                        rules: [
                                          { required: false, message: "" },
                                        ],
                                      },
                                    ],
                                    expression:
                                      "['uscCode', { rules: [{ required: false, message: '' }] }]",
                                  },
                                ],
                                attrs: {
                                  "max-length": 20,
                                  disabled: _vm.show,
                                  placeholder: "请输入社会统一信用代码",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "省市区" } },
                            [
                              _c("a-cascader", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["mbrAreaList"],
                                    expression: "['mbrAreaList']",
                                  },
                                ],
                                attrs: {
                                  placeholder: "请选择所在区域",
                                  options: _vm.treeData,
                                  fieldNames: {
                                    label: "areaName",
                                    value: "areaId",
                                    children: "children",
                                  },
                                  disabled: _vm.show,
                                },
                                on: { change: _vm.handleChange7 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "详细地址" } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "address",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "请输入详情地址",
                                          },
                                        ],
                                      },
                                    ],
                                    expression:
                                      "['address', { rules: [{ required: true, message: '请输入详情地址' }] }]",
                                  },
                                ],
                                attrs: { disabled: _vm.show },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    {
                      staticStyle: {
                        margin: "5px 0 15px 0",
                        "font-weight": "bold",
                        "font-size": "15px",
                      },
                      attrs: { gutter: 24 },
                    },
                    [_vm._v(" 重要标签 ")]
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "客户类型" } },
                            [
                              _c("a-select", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "custCategoryId",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "请选择客户类型",
                                          },
                                        ],
                                      },
                                      { initialValue: "1" },
                                    ],
                                    expression:
                                      "['custCategoryId', { rules: [{ required: true, message: '请选择客户类型' }] },{initialValue: '1'}]",
                                  },
                                ],
                                staticStyle: { width: "250px" },
                                attrs: {
                                  disabled: _vm.show,
                                  options: _vm.customerType,
                                },
                                on: { change: _vm.handleChange },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "客户性质" } },
                            [
                              _c("a-select", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "custNatureId",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "请选择客户性质",
                                          },
                                        ],
                                      },
                                      { initialValue: "1" },
                                    ],
                                    expression:
                                      "['custNatureId', { rules: [{ required: true, message: '请选择客户性质' }] },{initialValue: '1'}]",
                                  },
                                ],
                                staticStyle: { width: "250px" },
                                attrs: {
                                  disabled: _vm.show,
                                  options: _vm.customerProperty,
                                },
                                on: { change: _vm.handleChange3 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "所属细分行业" } },
                            [
                              _c("a-select", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "industryId",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "请选择细分行业",
                                          },
                                        ],
                                      },
                                      { initialValue: "1" },
                                    ],
                                    expression:
                                      "['industryId', { rules: [{ required: true, message: '请选择细分行业' }] },{initialValue: '1'}]",
                                  },
                                ],
                                staticStyle: { width: "250px" },
                                attrs: {
                                  disabled: _vm.show,
                                  options: _vm.subdividedTradeStructure,
                                },
                                on: { change: _vm.handleChange4 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "客户信息来源" } },
                            [
                              _c("a-select", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "sourceId",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "请选择客户来源",
                                          },
                                        ],
                                      },
                                      { initialValue: "1" },
                                    ],
                                    expression:
                                      "['sourceId',{ rules: [{ required: true, message: '请选择客户来源' }] },{initialValue: '1'},]",
                                  },
                                ],
                                staticStyle: { width: "250px" },
                                attrs: {
                                  disabled: _vm.show,
                                  options: _vm.customerSource,
                                },
                                on: { change: _vm.handleChange1 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "意向品系" } },
                            [
                              _c("a-select", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "wantStrainId",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "请选择意向品系",
                                          },
                                        ],
                                      },
                                      { initialValue: "1" },
                                    ],
                                    expression:
                                      "['wantStrainId',{ rules: [{ required: true, message: '请选择意向品系' }] },{initialValue: '1'},]",
                                  },
                                ],
                                staticStyle: { width: "250px" },
                                attrs: {
                                  disabled: _vm.show,
                                  options: _vm.wantStrainOption,
                                },
                                on: { change: _vm.handleChangeStarin },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "了解柳汽主要渠道" } },
                            [
                              _c("a-select", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "learnTypeId",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "请选择了解到柳汽的方式",
                                          },
                                        ],
                                      },
                                    ],
                                    expression:
                                      "['learnTypeId',{ rules: [{ required: true, message: '请选择了解到柳汽的方式' }] }]",
                                  },
                                ],
                                staticStyle: { width: "250px" },
                                attrs: {
                                  options: _vm.understand,
                                  disabled: _vm.show,
                                  placeholder: "请选择了解到柳汽的方式",
                                },
                                on: { change: _vm.handleChange5 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "是否向厂家进行组织客户报备" } },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "isReport",
                                        {
                                          rules: [
                                            {
                                              required: true,
                                              message: "请选择是否报备",
                                            },
                                          ],
                                        },
                                      ],
                                      expression:
                                        "['isReport', { rules: [{ required: true, message: '请选择是否报备' }] }]",
                                    },
                                  ],
                                  attrs: { disabled: _vm.show },
                                  on: { change: _vm.onChange },
                                },
                                [
                                  _c("a-radio", { attrs: { value: 1 } }, [
                                    _vm._v(" 是 "),
                                  ]),
                                  _c("a-radio", { attrs: { value: 0 } }, [
                                    _vm._v(" 否 "),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "最近意向等级" } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["lastWantLevelName"],
                                    expression: "['lastWantLevelName']",
                                  },
                                ],
                                attrs: { disabled: true },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "最近跟进时间" } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["lastFollowDate"],
                                    expression: "['lastFollowDate']",
                                  },
                                ],
                                attrs: { disabled: true },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "最近购买时间" } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["lastBuyDate"],
                                    expression: "['lastBuyDate']",
                                  },
                                ],
                                attrs: { disabled: true },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.entityForm.sourceName === "转介绍" ||
                  _vm.sourceId === 30001004
                    ? [
                        _c(
                          "a-row",
                          {
                            staticStyle: {
                              margin: "5px 0 15px 0",
                              "font-weight": "bold",
                              "font-size": "15px",
                            },
                            attrs: { gutter: 24 },
                          },
                          [_vm._v(" 转介绍人 ")]
                        ),
                        _c(
                          "a-row",
                          { attrs: { gutter: 24 } },
                          [
                            _c(
                              "a-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "a-form-item",
                                  { attrs: { label: "姓名" } },
                                  [
                                    _c("a-input", {
                                      directives: [
                                        {
                                          name: "decorator",
                                          rawName: "v-decorator",
                                          value: [
                                            "introducer",
                                            {
                                              rules: [
                                                {
                                                  required: false,
                                                  message: "请输入转介绍人姓名",
                                                },
                                              ],
                                            },
                                          ],
                                          expression:
                                            "['introducer', { rules: [{ required: false, message: '请输入转介绍人姓名' }] }]",
                                        },
                                      ],
                                      attrs: {
                                        disabled: _vm.show,
                                        placeholder: "请输入姓名",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "a-form-item",
                                  { attrs: { label: "手机" } },
                                  [
                                    _c("a-input", {
                                      directives: [
                                        {
                                          name: "decorator",
                                          rawName: "v-decorator",
                                          value: [
                                            "introducerPhone",
                                            {
                                              rules: [
                                                {
                                                  required: false,
                                                  message: "请输入转介绍人手机",
                                                },
                                              ],
                                            },
                                          ],
                                          expression:
                                            "['introducerPhone', { rules: [{ required: false, message: '请输入转介绍人手机' }] }]",
                                        },
                                      ],
                                      attrs: {
                                        disabled: _vm.show,
                                        placeholder: "请输入手机",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false",
                  },
                ],
                staticClass: "info_box",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.has === 1 ? "▶ 系统信息" : "▼ 系统信息"
                  ),
                },
                on: { click: _vm.foldTwo },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "最近联系时间" } },
                            [
                              _c("a-input", {
                                staticClass: "a_input",
                                attrs: { disabled: "" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "创建时间" } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "createDate",
                                      {
                                        rules: [
                                          {
                                            required: false,
                                            message: "Please input your note!",
                                          },
                                        ],
                                      },
                                    ],
                                    expression:
                                      "['createDate', { rules: [{ required: false, message: 'Please input your note!' }] }]",
                                  },
                                ],
                                staticClass: "a_input",
                                attrs: { disabled: "" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "好友来源" } },
                            [
                              _c("a-input", {
                                staticClass: "a_input",
                                attrs: { disabled: "" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "系统来源" } },
                            [
                              _c("a-input", {
                                staticClass: "a_input",
                                attrs: { disabled: "" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "联系人编号" } },
                            [
                              _c("a-input", {
                                staticClass: "a_input",
                                attrs: { disabled: "" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "联系人添加时间" } },
                            [
                              _c("a-input", {
                                staticClass: "a_input",
                                attrs: { disabled: "" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "获取联系人时间" } },
                            [
                              _c("a-input", {
                                staticClass: "a_input",
                                attrs: { disabled: "" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.index === 2,
              expression: "index===2",
            },
          ],
          staticClass: "two_box",
        },
        [
          !_vm.dealRecordList || _vm.dealRecordList.length < 1
            ? _c("div", { staticStyle: { "text-align": "center" } }, [
                _vm._v("暂无数据~"),
              ])
            : _vm._l(_vm.dealRecordList, function (item, index) {
                return _c("div", { key: index, staticClass: "transaction" }, [
                  _c("div", { staticClass: "transaction_word" }, [
                    _vm._v("品系：" + _vm._s(item.strainName)),
                  ]),
                  _c("div", { staticClass: "transaction_word" }, [
                    _vm._v("车辆类别：" + _vm._s(item.carType)),
                  ]),
                  _c("div", { staticClass: "transaction_word" }, [
                    _vm._v("车型：" + _vm._s(item.carModel)),
                  ]),
                  _c("div", { staticClass: "transaction_word" }, [
                    _vm._v("底盘号：" + _vm._s(item.vin)),
                  ]),
                  _c("div", { staticClass: "transaction_word" }, [
                    _vm._v("驱动形式：" + _vm._s(item.driverModel)),
                  ]),
                  _c("div", { staticClass: "transaction_word" }, [
                    _vm._v("订车时间：" + _vm._s(item.estimateBuyDate)),
                  ]),
                  _c("div", { staticClass: "transaction_word" }, [
                    _vm._v("订车数量：" + _vm._s(item.buyCount)),
                  ]),
                ])
              }),
        ],
        2
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.index === 3,
              expression: "index===3",
            },
          ],
        },
        [
          !_vm.followRecordList || _vm.followRecordList.length < 1
            ? _c(
                "div",
                {
                  staticStyle: { "text-align": "center", "margin-top": "11px" },
                },
                [_vm._v("暂无数据~ ")]
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "follow_up_box" },
            _vm._l(_vm.followRecordList, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "follow_up_small_box" },
                [
                  _c("div", { staticClass: "follow_up_word fix" }, [
                    item.avatar
                      ? _c("div", { staticClass: "follow_up_img l" }, [
                          _c("img", { attrs: { src: item.avatar, alt: "" } }),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "l" }, [
                      _c("div", { staticClass: "follow_up_name" }, [
                        _vm._v(_vm._s(item.custName)),
                      ]),
                      _c("div", [_vm._v(" " + _vm._s(item.createDate))]),
                    ]),
                  ]),
                  _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                    _vm._v("具体跟进内容：" + _vm._s(item.reportDesc)),
                  ]),
                  _c("div", [
                    _vm._v("跟进类型：" + _vm._s(item.reportTypeName)),
                  ]),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.index === 4,
              expression: "index===4",
            },
          ],
        },
        [
          _c("operationLog", {
            attrs: { operationLogList: _vm.operationLogList },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.index === 5,
              expression: "index===5",
            },
          ],
        },
        [
          _c("customerTrail", {
            attrs: { customerTrailList: _vm.customerTrailList },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.index === 6,
              expression: "index===6",
            },
          ],
        },
        [
          _c("vehicleOwnership", {
            attrs: { vehicleOwnershipList: _vm.vehicleOwnershipList },
          }),
        ],
        1
      ),
      !_vm.show
        ? _c(
            "a-space",
            { staticClass: "a-form-btn-box" },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.endEdit("cancelled")
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm._save(false)
                    },
                  },
                },
                [_vm._v("提交")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }